import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { Trad } from '../components/';

interface IPaginatoreState {
}

interface IPaginatoreProps {
    Pagina: number;
    Pagine: number;
    OnCambioPagina?: (sender: Paginatore, pagina: number) => void;
}

export class Paginatore extends React.PureComponent<IPaginatoreProps, IPaginatoreState> {
    public static defaultProps: Partial<IPaginatoreProps> = {
        OnCambioPagina: undefined
    };

    public constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render() {
        let PagInizio = this.props.Pagina - 4;
        if (PagInizio <= 1) PagInizio = 1;
        let PagFine = this.props.Pagina + 4;
        if (PagFine >= this.props.Pagine) PagFine = this.props.Pagine;
        var ListaPag = [];
        for (var P = PagInizio; P <= PagFine; P++) {
            let IP = P; //usando P al posto di IP la chiamata alla callback passa sempre l'ultimo valore del ciclo for
            ListaPag.push(<li key={P}>
                <a href="#" className={IP == this.props.Pagina ? "kt-datatable__pager-link kt-datatable__pager-link-number kt-datatable__pager-link--active" : "kt-datatable__pager-link kt-datatable__pager-link-number"} onClick={(e) => { e.preventDefault(); if (this.props.OnCambioPagina != undefined) this.props.OnCambioPagina(this, IP); }}>{P}</a>
            </li>);
        }

        if (this.props.Pagine == undefined || this.props.Pagine == 0) {
            return false;
        }
        return <div className="kt-datatable kt-datatable--default TextCenter" style={{ height: 55 }}>
            <div className="kt-datatable__pager kt-datatable--paging-loaded clearfix">
                <ul className="kt-datatable__pager-nav">
                    <li>
                        <a href="#" className="kt-datatable__pager-link kt-datatable__pager-link--first kt-datatable__pager-link" onClick={(e) => { e.preventDefault(); if (this.props.OnCambioPagina != undefined && this.props.Pagina > 1) this.props.OnCambioPagina(this, 1); }}>
                            <i className="la la-angle-double-left"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#" className="kt-datatable__pager-link kt-datatable__pager-link--prev kt-datatable__pager-link" onClick={(e) => { e.preventDefault(); if (this.props.OnCambioPagina != undefined && this.props.Pagina > 1) this.props.OnCambioPagina(this, this.props.Pagina - 1); }}>
                            <i className="la la-angle-left"></i>
                        </a>
                    </li>
                    {ListaPag}
                    <li>
                        <a href="#" className="kt-datatable__pager-link kt-datatable__pager-link--next kt-datatable__pager-link" onClick={(e) => { e.preventDefault(); if (this.props.OnCambioPagina != undefined && this.props.Pagina < this.props.Pagine) this.props.OnCambioPagina(this, this.props.Pagina + 1); }}>
                            <i className="la la-angle-right"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#" className="kt-datatable__pager-link kt-datatable__pager-link--last kt-datatable__pager-link" onClick={(e) => { e.preventDefault(); if (this.props.OnCambioPagina != undefined && this.props.Pagina < this.props.Pagine) this.props.OnCambioPagina(this, this.props.Pagine <= 0 ? 1 : this.props.Pagine); }}><i className="la la-angle-double-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Paginatore.tsx